import { HostListener, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfirmationService } from '../services/confirmation.service';
import { DirtinessService } from '../services/dirtiness.service';

@Injectable({
  providedIn: 'root'
})
export class FulfilmentGuard implements CanActivate {
  isDirty: boolean = false;
  constructor(
    private _dirtnessService: DirtinessService,
    private _confirmationService: ConfirmationService
  ) {
    this._dirtnessService
      .dirtinessChanges()
      .subscribe(isDirty => {
        this.isDirty = isDirty;
      })
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  @HostListener('window:beforeunload')
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    

      return this._confirmationService
        .confirmLeavingPage(
          "Confirm if you have finished scanning",
          "Check if you have finished scanning all the items. Are you sure you want to leave this page?",
        )
    } 
}
